class AppSettings {
    private static instance: AppSettings;
    private settings: Record<string, unknown>; // Consider specifying a more precise type than 'any' if possible
  
    private constructor() {
      this.settings = {}; // Initialize the settings container
    }
  
    public static getInstance(): AppSettings {
      if (!AppSettings.instance) {
        AppSettings.instance = new AppSettings();
        Object.freeze(AppSettings.instance);
      }
      return AppSettings.instance;
    }
  
    public setSetting(key: string, value: unknown): void { // Adjust the value type as needed
      this.settings[key] = value;
    }
  
    public getSetting(key: string): unknown { // Adjust the return type as needed
      return this.settings[key];
    }
  }
  
  export const appSettingsInstance = AppSettings.getInstance();
  